import { render, staticRenderFns } from "./LayoutSelector.vue?vue&type=template&id=4e2453c0"
import script from "./LayoutSelector.vue?vue&type=script&lang=js"
export * from "./LayoutSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports